import type { Player } from "./types";

/** A follow override belongs only to an observer or an eliminated competitor. */
export function followTarget(
  players: readonly Pick<Player, "id" | "alive">[],
  localId: number | null,
  requestedId: number | null,
): number | null {
  if (players.some((player) => player.id === localId && player.alive))
    return null;
  const selected = players.find((player) => player.id === requestedId);
  return (
    (selected?.alive ? selected.id : undefined) ??
    players.find((player) => player.alive)?.id ??
    selected?.id ??
    players.find((player) => player.id === localId)?.id ??
    players[0]?.id ??
    null
  );
}
